import { NgModule } from '@angular/core';
import { AppSharedModule } from '../app-shared.module';
import { ComponentsModule } from '../components/components.module';
import { TipoComplementoListaComponent } from './tipo-complemento-lista/tipo-complemento-lista.component';
import { TipoComplementoRoutingModule } from './tipo-complemento.routing';
import { TipoComplementoService } from './tipo-complemento.service';
import { TipoComplementoVisualizacaoComponent } from './tipo-complemento-visualizacao/tipo-complemento-visualizacao.component';


@NgModule({
  imports: [
    AppSharedModule,
    ComponentsModule,
  ],
  declarations: [
    TipoComplementoListaComponent,
    TipoComplementoVisualizacaoComponent,
  ],
  exports: [
    TipoComplementoRoutingModule
  ],
  providers: [
    TipoComplementoService
  ]
})
export class TipoComplementoModule {}
